<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ (reactivateMode ? 'admin.reactivateUser.title' : 'admin.deactivateUser.title') | translate }}
    </h5>
    <button type="button"
      class="btn-close"
      aria-label="Close"
      (click)="activeModal.dismiss()"
    ></button>
  </div>

  <div class="modal-body">
    @if (error) {
      <div class="alert alert-danger mb-3">
        {{ (reactivateMode
        ? 'admin.reactivateUser.error'
        : 'admin.deactivateUser.error') | translate }}
      </div>
    }

    {{ (reactivateMode
    ? 'admin.reactivateUser.message'
    : 'admin.deactivateUser.message') | translate: { userName: user.name } }}
  </div>

  <div class="modal-footer">
    <button id="btn-cancel-user-form"
      class="btn btn-link link-secondary"
      (click)="activeModal.dismiss()">
      {{ 'no' | translate }}
    </button>

    <button id="btn-submit-user-form"
      class="btn btn-primary ms-auto"
      (click)="confirmActivation()"
      >
      @if (!submitting) {
        <span>{{ 'yes' | translate }}</span>
      }
      @if (submitting) {
        <span class="spinner-border text-primary" role="status"></span>
      }
    </button>
  </div>
</div>